
export function formatNumber(number) {
    return new Intl.NumberFormat('pt-BR', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    }).format(Number(number));
}

export function formatCurrency(number) {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(number));
}

export function formatPercentage(number) {
    return new Intl.NumberFormat('pt-BR', { style: 'percent' }).format(Number(number));
}

export function getPercentageFromTotal(total, value) {
    return (Number(value) / Number(total)) * 100;
}

/**
 * Normaliza a origem de URLs de assets do próprio app.
 *
 * Alguns campos (ex.: `marker` do empreendimento) foram gravados no banco como
 * URL absoluta com o domínio de produção congelado, o que quebra a imagem em
 * qualquer outro domínio (dev/staging). Reescreve apenas assets internos
 * (`/img/...`) para um caminho relativo à origem atual; URLs externas — como
 * ícones do maps.google.com ou marcadores em storage/S3 — são preservadas.
 */
export function toCurrentOrigin(url) {
    if (!url || typeof url !== 'string') {
        return url;
    }

    try {
        const parsed = new URL(url, window.location.origin);

        if (parsed.pathname.startsWith('/img/')) {
            return parsed.pathname + parsed.search;
        }

        return url;
    } catch (e) {
        return url;
    }
}

export function slugify( string ){
    return string
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9 ]/g, '')
        .replace(/\s+/g, '-');
}
